/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { AuthentificationService } from './sharedServices/authentification.service';
import { Router } from '@angular/router';
import { LoaderService } from './sharedServices/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public userAuthenticated = false;

  constructor(
    private readonly authentificationService: AuthentificationService,
    private readonly router: Router,
    private readonly loaderService: LoaderService) {

    this.authentificationService.loginChanged.subscribe(userAuthenticated => {
      this.userAuthenticated = userAuthenticated;

    });
  }

  ngOnInit() {
   setTimeout(()=>{ this.authentificationService.isLoggedIn().then(async userAuthenticated => {
      this.userAuthenticated = userAuthenticated;
      if (!this.userAuthenticated) {
         this.authentificationService.login();
      } else {
        this.loaderService.display(true);
        this.router.navigate(['app-search-fitting'], {replaceUrl: true});
      }

    })},4000);
  }


}
